import { useEffect, useMemo, useState } from 'react'
import Wrapper from '../styles/Wrapper'
import { ThreeDots } from 'react-loader-spinner';
import moment from 'moment';
import { APIError, getUserName, showUserTypeBadge } from '../../../core/utils';
import NoRecord from '../../../assets/SharedComponents/Table/NoRecord';
import { useParams } from 'react-router-dom';
import { APP_URLS } from '../../../api/url';
import API from '../../../api/axios';
import { toast } from 'react-toastify';
import JSONModal from '../../../assets/SharedComponents/JSONModal/JSONModal';
import VerifyIntegrity from '../Logs/Components/VerifyIntegrity';

const LogDetails = () => {

    const { logId } = useParams();

    const [log, _log] = useState([])

    const [loader, _loader] = useState(false);

    const isSubsidiary = useMemo(() => {
        return log.subsidiaries_info?.[0]
    }, [log?.subsidiaries_info])

    useEffect(() => {
        if (!logId) return
        (() => {
            _loader(true);

            API.get(`${APP_URLS.VAT_AUDIT_LOGS}/${logId}`)
                .then((res) => {
                    const resp = res.data;
                    if (resp.success === true) {
                        _log(resp.data.item)
                    } else {
                        toast.error(resp.message, { position: toast.POSITION.TOP_RIGHT });
                    }
                })
                .catch((error) => {
                    let error_message = APIError(error);
                    toast.error(error_message, { position: toast.POSITION.TOP_RIGHT });
                })
                .finally(() => {
                    _loader(false);
                });
        })()
    }, [])

    return (
        <Wrapper>
            <h1>Logs</h1>
            <div className='filters'></div>
            <div className='record-summary'></div>
            <div className='tableContainer'>
                <table className='auctionTable'>
                    <thead className='tableHead'>
                        <tr className='table-row'>
                            <th>ID</th>
                            <th>Request ID </th>
                            <th>SHA256_hash </th>
                            <th className='user-links'>User/Subsidiary</th>
                            <th>
                                VAT Number
                                <br />
                                (Country Code + Number)
                            </th>
                            <th>
                                Is Valid?
                                <br />
                                Validated At
                            </th>
                            <th>
                                Is Archived?
                                <br />
                                Archived At
                            </th>
                            <th>Response Data</th>
                            <th>Integrity Verified</th>
                            <th>Created At</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    {loader ?
                        <div className="d-flex justify-content-center three-dot">
                            <ThreeDots
                                height="150"
                                width="150"
                                radius="9"
                                color="#637df4"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{}}
                                wrapperClassName=""
                                visible={true}
                            />
                        </div> :
                        <tbody>
                            <tr className="table-row">
                                <td>{log.id}</td>
                                <td>{log.request_id}</td>
                                <td>{log.sha256_hash}</td>
                                <td className='user-links'>
                                    <a
                                        href={isSubsidiary
                                            ? `/company-details/${isSubsidiary.id}`
                                            : `/detail-member/${log.user_id}`
                                        }
                                        className="link"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <b>
                                            {isSubsidiary ? isSubsidiary.name : getUserName(log.user)}
                                            {showUserTypeBadge(isSubsidiary ? 'subsidiary' : 'user')}
                                        </b>
                                    </a>
                                </td>
                                <td>
                                    {log.country_code} {log.vat_number}
                                </td>
                                <td>
                                    <span className={`status ${log.validated_at ? 'status-active' : ''}`}></span>
                                    {log.validated_at ?
                                        <>
                                            <br />
                                            {moment(log.validated_at)
                                                .tz("Europe/Amsterdam")
                                                .format("DD-MM-YYYY HH:mm")}
                                        </>
                                        : null
                                    }
                                </td>
                                <td>
                                    <span className={`status ${log.archived_at ? 'status-active' : ''}`}></span>
                                    {log.archived_at ?
                                        <>
                                            <br />
                                            {moment(log.archived_at)
                                                .tz("Europe/Amsterdam")
                                                .format("DD-MM-YYYY HH:mm")}
                                        </>
                                        : null
                                    }
                                </td>
                                <td>
                                    <JSONModal buttonText="Show response data" modalHeader="Response data" jsonData={log?.response_data} />
                                </td>
                                <td>
                                    <span className={`status ${log.integrity_verified ? 'status-active' : ''}`}></span>
                                </td>
                                <td>
                                    {moment(log.created_at)
                                        .tz("Europe/Amsterdam")
                                        .format("DD-MM-YYYY HH:mm")}
                                </td>
                                <td>
                                    <VerifyIntegrity logId={log?.id} />
                                </td>
                            </tr>
                        </tbody>
                    }
                </table>
            </div>
        </Wrapper>
    )
}

export default LogDetails